import { Box, css, styled } from "@mui/material";

import { getColor } from "@hooks";
import Logo from "@public/_common/colorful_bracket_logo.svg";
import LogoAsText from "@public/_common/current_color_text_logo.svg";

import { PageElementContainer } from "../PageContainer";

export const StyledPageElementContainer = styled(PageElementContainer)(
  ({ theme }) => css`
    border-top: 1px solid ${getColor(c => c.tokens.stroke["soft-200"], theme)};
    background: ${theme.footerBackgroundGradient};

    ${theme.breakpoints.up("mobile")} {
      margin-top: 16px;
    }

    ${theme.breakpoints.up("tablet")} {
      margin-top: 24px;
    }

    ${theme.breakpoints.up("desktop")} {
      margin-top: 32px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      margin-top: 48px;
    }
  `,
);

export const FooterContainer = styled(Box)(
  ({ theme }) => css`
    max-width: ${theme.breakpoints.values.desktopXl}px;
    margin: 0 auto;

    ${theme.breakpoints.up("mobile")} {
      padding: 48px 0 24px 0;
    }

    ${theme.breakpoints.up("tablet")} {
      padding: 64px 0;
    }

    ${theme.breakpoints.up("desktopXl")} {
      padding: 80px 0;
    }
  `,
);

export const BracketLogo = styled(Logo)`
  flex-shrink: 0;
  filter: drop-shadow(0 0 20px #ffffff66);
`;

export const TextLogo = styled(LogoAsText)`
  height: 24px;
`;
